<!-- Feature Hero Area of the Home Page -->
<app-promotional-hero *ngIf="isFeatureHeroAllowed && (isAuthenticated$ | async)"></app-promotional-hero>
<div class="container">
  <div class="row no-gutters">
    <div class="col-12 col-xl-8">
      <section id="welcome">
        <div class="row">
          <div class="col">
            <h1>Welcome to the {{ siteName }}</h1>
            <h3 *ngIf="!(hideSubheading$ | async)">
              No single software and data provider possesses the combined experience, ability and product catalog of
              Precisely.
            </h3>
          </div>
        </div>
        <ng-container>
          <ng-container>
            <div class="row text-center" *ngIf="!((isAuthenticated$ | async) || isMasterCardUser)">
              <div class="col m-3" *appIfFeature="'!hide_signup_link'">
                <button class="btn btn-primary" (click)="navigateToSignUp()">Not a registered user? Sign up now</button>
              </div>
              <div class="col m-3" *appIfFeature="'hide_signup_link'">
                <button class="btn btn-primary" (click)="navigateToContactUs()">
                  Not a registered user? Contact Us
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </section>
      <section class="inverted" id="access">
        <div class="row">
          <h3 class="col-12 section-header">Access</h3>
          <ng-container>
            <app-home-item
              *appIfFeature="'data_entitlement_v2'"
              [isAuthenticated]="isAuthenticated$ | async"
              iconClass="pbi-download"
              inverted="true"
              name="My Data Products"
              actionLabel="my-products"
              routeLink="/data"
              subheading="Download your active data subscriptions"
            ></app-home-item>
            <app-home-item
              *appIfFeature="'!data_entitlement_v2'"
              [isAuthenticated]="isAuthenticated$ | async"
              iconClass="pbi-download"
              inverted="true"
              name="My Data Products"
              actionLabel="my-products"
              routeLink="/products"
              subheading="Download your active data subscriptions"
            ></app-home-item>
            <app-home-item
              [isAuthenticated]="isAuthenticated$ | async"
              iconClass="pbi-download"
              inverted="true"
              name="My Software Products"
              actionLabel="my-software-products"
              routeLink="/software"
              subheading="Download your active software subscriptions"
            ></app-home-item>
          </ng-container>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-cloud-download"
            inverted="true"
            name="Automatic Downloads"
            actionLabel="automatic-downloads"
            routeLink="/autodownload"
            subheading="Updates via Auto Download Tool and SDK"
          ></app-home-item>
          <!--        TODO implement a hasPermission directive.-->
          <ng-container *ngIf="isAuthenticated$ | async">
            <app-home-item
              [isAuthenticated]="isAuthenticated$ | async"
              *appHasPermission="'userAccessManagement'"
              iconClass="pbi-users"
              inverted="true"
              name="User Access Management"
              actionLabel="user-access-managment"
              routeLink="/uam"
              subheading="Manage your organization's data access"
            ></app-home-item>
          </ng-container>
          <!--<app-home-item
            *appHasPermission="'myClients'"
            iconClass="pbi-entity"
            inverted="true"
            actionLabel="my-clients"
            name="My Clients"
            routeLink="/clients"
            subheading="Monitor your clients' data updates"
          ></app-home-item>-->
        </div>
      </section>
      <section id="explore">
        <div class="row">
          <h3 class="col-12 section-header">Explore</h3>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-location-pin"
            actionLabel="map-explorer"
            name="Map Explorer"
            routeLink="/visualization/map-explorer"
            subheading="Explore our data in a live mapping application"
          ></app-home-item>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-bulb"
            name="Data Guide"
            actionLabel="data-guide"
            subheading="Gain insight, drive growth and minimize risk."
            uri="https://dataguide.precisely.com"
          ></app-home-item>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-lower-value"
            name="Property Risk Profile Demo"
            actionLabel="property-risk-profile-demo"
            routeLink="/usecases/property-risk"
            subheading="The data an underwriter needs, in a few clicks"
            *appIfFeature="'!hide_demo_sites'"
          ></app-home-item>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-degree"
            actionLabel="sample-datasets"
            name="Sample Datasets"
            routeLink="/samples"
            subheading="Test drive data with free sample downloads"
          ></app-home-item>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            iconClass="pbi-home"
            actionLabel="home-search-real-estate-demo"
            name="Home Search Real Estate Demo"
            routeLink="/usecases/home-search-real-estate"
            subheading="Find the right house, in the right location."
            *appIfFeature="'!hide_demo_sites'"
          ></app-home-item>
          <app-home-item
            iconClass="pbi-info-circle"
            actionLabel="data-products-help"
            name="Product Documentation"
            subheading="Learn More about Precisely Products"
            uri="https://help.precisely.com/"
            *appIfFeature="'product_documentation_page'"
          ></app-home-item>
        </div>
      </section>
      <section id="contact">
        <div class="row">
          <h3 class="col-12 section-header">Contact</h3>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            actionLabel="contact-sales"
            *ngIf="contactSalesAnchorUrl || contactSalesRouterLink"
            [name]="contactSalesAnchorText"
            [routeLink]="contactSalesRouterLink"
            [uri]="contactSalesAnchorUrl"
            iconClass="pbi-chat-conversation"
            subheading="Talk to one of our data specialists"
          ></app-home-item>
          <app-home-item
            [isAuthenticated]="isAuthenticated$ | async"
            actionLabel="contact-support"
            *ngIf="contactSupportAnchorUrl || contactSupportRouterLink"
            [name]="contactSupportAnchorText"
            [routeLink]="contactSupportRouterLink"
            [uri]="contactSupportAnchorUrl"
            iconClass="pbi-headset"
            subheading="Our best-in-class support team is here to help"
          ></app-home-item>
        </div>
      </section>
    </div>
    <div
      class="col-4 d-xl-block"
      id="homeImage"
      style="background-image: url('/assets/images/PDE-home-woman.jpg')"
    ></div>
  </div>
</div>
